import React from "react";
import LogoAr from "../Images/LogoAr-100.jpg"

function Footer () {
    return(
        <div className="Footer">
            <div className="container">
                <ul>
                    <li>دریافت نسخه آزمایشی</li>
                    <li>خرید نسخه پرو</li>
                    <li>دریافت پشتیبانی</li>
                    <li>09220382792</li>
                </ul>
                <ul>
                  <img className="footerLogo" src={LogoAr} />
                  <p>power by arvhavive.com</p>
                </ul>
            </div>
        </div>
    )
}

export default Footer
